'use strict';
import LalamoveResource from '../LalamoveResource';
import resourceMethod from '../Method';
export default LalamoveResource.extend({
    create: resourceMethod({
        method: 'POST',
        path: 'quotations',
    }),
});
//# sourceMappingURL=Quotations.js.map